import axios from 'axios'
import { useState, useEffect, HtmlHTMLAttributes } from 'react'

import styles from './dynamic-svg.module.scss'

export interface SvgIconProps extends HtmlHTMLAttributes<HTMLDivElement> {
	width?: string | number
	height?: string | number
	color?: string
	url: string
}

export function SvgIcon({ url, color, width, height, ...props }: SvgIconProps) {
	const [svgContent, setSvgContent] = useState<string>('')

	async function onFetch() {
		const response = await axios.get(url)

		if (response.status === 200) {
			setSvgContent(response.data)
		}
	}

	useEffect(() => {
		onFetch()
	}, [])

	return (
		<div
      {...props}
			className={styles.iconWrap}
			style={
				{
					'--icon-min-width': typeof width === 'number' ? `${width}px` : width,
					'--icon-min-height': typeof height === 'number' ? `${height}px` : height,
				} as React.CSSProperties
			}
			dangerouslySetInnerHTML={{
				__html: `${svgContent}`,
			}}
		></div>
	)
}
